import payment from './payment'
import openBankingPayment from './open-banking-payment'

export default {
  name: 'FinancialPayment',
  path: 'payment',
  meta: {
    label: 'payment',
    auth: 'payment'
  },
  component: {
    name: 'Payment',
    render(c) {
      return c('router-view')
    }
  },
  children: [payment, openBankingPayment]
}
